<template>
  <div>
    <van-row :gutter="10">
      <van-col :span="24">
        <img src="../../assets/images/xiaoqu.png" width="100%" v-if="!currentIndex" @click="select" />
        <div
          :class="{'form-box-tag':true,'active':currentIndex ? true:false}"
          v-if="currentIndex"
          @click="select"
        >{{ctitle}}</div>
      </van-col>
    </van-row>
    <iframe
      id="mapPage"
      v-if="showMap"
      frameborder="0"

      src="//apis.map.qq.com/tools/locpicker?search=1&type=1&coord=29.999183,108.114013&key=MRCBZ-P6NW3-I4P3B-3GYN4-XCESS-MMFVP&referer=myapp"
    ></iframe>
  </div>
</template>

<script>
import { Row, Col } from "vant";

export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col
  },
  data() {
    return {
      currentIndex: false,
      showMap: false,
      ctitle: this.title,
      clat: this.lat,
      clng: this.lng
    };
  },
  props: {
    title: {
      type: String,
      default: "选择位置"
    },
    lat: {
      type: String,
      default: ""
    },
    lng: {
      type: String,
      default: ""
    }
  },
  mounted() {
    var self = this;
    window.addEventListener(
      "message",
      function(event) {
        // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
        var loc = event.data;
        if (loc && loc.module == "locationPicker") {
          //防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
          console.log(loc);
          self.$emit("change", {
            title: loc.poiname,
            address: loc.poiaddress,
            lat: loc.latlng.lat.toString(),
            lng: loc.latlng.lng.toString()
          });
          self.change(loc);
        }
      },
      false
    );
  },
  watch: {
    title: function() {
      if (this.title != "") {
        this.ctitle = this.title;
        this.currentIndex = true;
      }
    },
    lat: function() {
      if (this.lat != "") {
        this.clat = this.lat;
      }
    },
    lng: function() {
      if (this.lng != "") {
        this.clng = this.lng;
      }
    }
  },
  methods: {
    select() {
      this.showMap = true;
      this.currentIndex = true;
    },
    change(loc) {
      this.showMap = false;
      this.ctitle = loc.poiaddress;
    }
  }
};
</script>

<style scoped>
#mapPage {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}

.form-box-tag {
  background-color: #f8f8f8;
  line-height: 32px;
  text-align: center;
  color: #555;
  border-radius: 4px;
  cursor: pointer;
}
.form-box-tag.active {
  background-color: #feefe9;
  color: #f56229;
}
</style>>



